import React, { useState } from "react";
import SvgMapper from "../../../features/common/SvgMapper";
import { demo } from "./ScoreDemo";
import PreChecksGrid from "./PreCheckGrid";
import SectionPanel from "./SectionPanel";




export default function ScoreTab({ data }) {
    
    const sections = Array.isArray(data) && data.length ? data : demo;
    const [open, setOpen] = useState(() => new Set(["pre-checks"])); // open pre-checks by default

    const toggle = (id) =>{
        setOpen((prev) => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;;
        });
    };


    return (
        <>
            {sections.map((sec) => {
                const isOpen = open.has(sec.id);
                // Special layout for pre-checks: grid
                if (sec.id === "pre-checks") {
                    return (
                        <div key={sec.id} className="border border-gray-200 rounded-lg">
                            <button
                                type="button"
                                onClick={() => toggle(sec.id)}
                                aria-expanded={isOpen}
                                aria-controls={`${sec.id}-panel`}
                                className="w-full p-4 flex items-center justify-between hover:bg-gray-50"
                            >
                                <div className="flex items-center space-x-3">
                                    {SvgMapper.dropdown({className:`w-5 h-5 transform transition-transform text-gray-400 ${open ? "rotate-180" : "rotate-0"}` })}
                                    <h3 className="text-lg font-semibold text-gray-900">{sec.title}</h3>
                                    {sec.subtitle && <p className="text-sm text-gray-500">{sec.subtitle}</p>}
                                </div>


                            </button>

                            <div id={`${sec.id}-panel`} className={`${isOpen ? "block" : "hidden"} border-t border-gray-200 p-4`}>
                                {/* GRID: 1 column on small screens, 2 columns on md+ */}
                                <PreChecksGrid items={sec.items} />
                            </div>
                        </div>
                    );
                }

                // Default stacked behavior for other sections
                return (
                    <div key={sec.id} className="border border-gray-200 rounded-lg">
                        <button
                            type="button"
                            onClick={() => toggle(sec.id)}
                            aria-expanded={isOpen}
                            aria-controls={`${sec.id}-panel`}
                            className="w-full p-4 flex items-center justify-between hover:bg-gray-50"
                        >
                            <div className="flex items-center space-x-3">
                                 {SvgMapper.dropdown({className:`w-5 h-5 transform transition-transform text-gray-400 ${open ? "rotate-180" : "rotate-0"}` })}
                                <h3 className="text-lg font-semibold text-gray-900">{sec.title}</h3>
                                {sec.subtitle && <p className="text-sm text-gray-500">{sec.subtitle}</p>}
                                
                                 {/* Score & ProgressBar logic */}
                                <div className="flex items-center space-x-2">
                                    {sec.meta?.score && <span className="text-sm text-gray-500">{sec.meta.score}</span>}
                                    {typeof sec.meta?.progress === "number" && (
                                        <div className="w-20 h-2 bg-gray-200 rounded-full">
                                            <div className={`h-full 
                                                    ${sec.meta.progress >= 80
                                                    ? "bg-green-400"
                                                    : sec.meta.progress >= 60
                                                        ? "bg-yellow-400"
                                                        : "bg-red-400"} rounded-full`}
                                                style={{ width: `${sec.meta.progress}%` }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>


                        </button>

                        <div id={`${sec.id}-panel`} className={`${isOpen ? "block" : "hidden"} border-t border-gray-200 p-4 space-y-4`}>
                            <SectionPanel sections={sec.sections}/>
                        </div>
                    </div>
                );
            })}
        </>
    );
}
